// User-facing copy aligned with `helix-web/contexts/CartContext.js` (Comfort Crew). English-only; see docs.

/** addCartItems validation / generic failure */
export const ADD_TO_CART_GENERIC =
  'Your items were not added to the cart due to an unexpected error. Please try again in a minute or chat with our Comfort Crew to place your order.';

/** Reserved for deleteCartItem or equivalent */
export const REMOVE_FROM_CART_GENERIC =
  'Something went wrong while removing the item from your cart. Please try again later or chat with our Comfort Crew for assistance.';

/** Reserved for clearCart or equivalent */
export const CLEAR_CART_ERROR =
  'Your items were not updated due to an unexpected error. Please try again in a minute or chat with our Comfort Crew to place your order.';

/** getCart API failure */
export const GET_CART_GENERIC =
  'Something went wrong while loading your cart. Please try again later or chat with our Comfort Crew for assistance.';
